<tab-view [class.npe]="_draggingFile" (tabChange)="_handleTabChange($event)" (dragenter)="_handleDragEnter($event)" ondragover="event.preventDefault()">
    <tab-page title="Calculatie">
        <ng-template>
            <paged-line-table #table [calculation]="_calculation" [active]="_selectedTabIndex | equals:0"></paged-line-table>
        </ng-template>
    </tab-page>
    <!-- <tab-page title="Staart">
        <ng-template>
            <tail-table #table [calculation]="_calculation" [active]="_selectedTabIndex | equals:1"></tail-table>
        </ng-template>
    </tab-page> -->
    <tab-page title="Info">
        <ng-template>
            <info-page></info-page>
        </ng-template>
    </tab-page>
</tab-view>

<!-- File drag-drop overlay -->
<div class="drag-overlay" (drop)="_handleDrop($event)" (dragleave)="_handleDragLeave($event)" *ngIf="_draggingFile" ondragover="event.preventDefault()">
    <div class="inner-container">
        <h1>Bestand importeren...</h1>
    </div>
</div>